import type { AllRouteEndpoints } from "../routeTypes";

export const customObjectsCustomObjectTypes = "/data_objects/data_object_types" as const;

export const customObjectsCustomObjectTypesCacheKeys: AllRouteEndpoints[] = [customObjectsCustomObjectTypes];
